import React from 'react'
import { includes } from 'lodash'
import { observer, inject } from 'mobx-react'

const SUPER_ADMIN_ROLES = ['super_admin']
const PARTNER_ADMIN_ROLES = ['partner_admin', ...SUPER_ADMIN_ROLES]
const COMMUNITY_ADMIN_ROLES = ['community_admin', ...PARTNER_ADMIN_ROLES]

export const isSuperAdmin = (user) => includes(SUPER_ADMIN_ROLES, user.role)
export const isPartnerAdmin = (user) => includes(PARTNER_ADMIN_ROLES, user.role)
export const isCommunityAdmin = (user) => includes(COMMUNITY_ADMIN_ROLES, user.role)

export const UserIsSpecificPartnerAdmin = (Comp) =>
  inject(({ mst: { topics } }, ownProps) => {
    const {
      match: {
        params: { slug }
      }
    } = ownProps
    const topic = topics.list.find((c) => c.slug === slug)
    if (!topic && !topics.topicLoading) {
      topics.loadBySlug(slug)
    }
    return { auth_topic: topic }
  })(
    observer(({ auth_topic, ...rest }) => {
      return auth_topic && auth_topic.canEdit && <Comp {...rest} />
    })
  )

export const UserIsSpecificPartnerAdminForPartner = (Comp) =>
  inject(({ mst: { auth } }, ownProps) => {
    const slug = ownProps.match.params.slug
    const user = auth.user
    return { auth_user: user, auth_slug: slug }
  })(
    observer(({ auth_user, auth_slug, ...rest }) => {
      if (!auth_user) return null
      const authorized = includes(auth_user.partnerSlugs, auth_slug)
      const allowed = isSuperAdmin(auth_user) || (isPartnerAdmin(auth_user) && authorized)
      return allowed ? <Comp {...rest} /> : null
    })
  )

export const VisibleGeneralCommunityAdmin = (Comp) =>
  inject(
    ({
      mst: {
        auth: { user }
      }
    }) => {
      return { auth_user: user }
    }
  )(
    observer(({ auth_user, ...rest }) => {
      return auth_user && auth_user.isCommunityAdmin() ? <Comp {...rest} /> : null
    })
  )

export const VisibleGeneralPartnerAdmin = (Comp) =>
  inject(
    ({
      mst: {
        auth: { user }
      }
    }) => {
      return { auth_user: user }
    }
  )(
    observer(({ auth_user, ...rest }) => {
      return auth_user && auth_user.isPartnerAdmin() ? <Comp {...rest} /> : null
    })
  )

export const VisibleOnlySuperAdmin = (Comp) =>
  inject(
    ({
      mst: {
        auth: { user }
      }
    }) => {
      return { auth_user: user }
    }
  )(
    observer(({ auth_user, ...rest }) => {
      return auth_user && auth_user.isSuperAdmin() ? <Comp {...rest} /> : null
    })
  )

export const VisibleOnlyUser = (Comp) =>
  inject(
    ({
      mst: {
        auth: { user }
      }
    }) => {
      return { auth_user: user }
    }
  )(
    observer(({ auth_user, ...rest }) => {
      return auth_user && auth_user.isUser() ? <Comp {...rest} /> : null
    })
  )
